export default __webpack_public_path__ + "static/shan-teas-83426f1630d234154bbc9b216d3dacba.png";